var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotesTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2624 17.188C36.2624 21.7467 34.3523 26.1187 30.9522 29.3422C27.5521 32.5657 22.9406 34.3766 18.1322 34.3766V55.9993C18.1322 55.9993 0 43.4012 0 17.188C0.0506496 12.6606 1.9832 8.33492 5.37796 5.15041C8.77271 1.9659 13.3555 0.179687 18.1312 0.179688C22.9068 0.179687 27.4897 1.9659 30.8844 5.15041C34.2792 8.33492 36.2117 12.6606 36.2624 17.188Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9999 17.188C79.9999 19.4452 79.531 21.6804 78.6199 23.7658C77.7087 25.8512 76.3733 27.7461 74.6897 29.3422C73.0062 30.9383 71.0075 32.2044 68.8079 33.0682C66.6082 33.932 64.2507 34.3766 61.8698 34.3766V55.9993C61.8698 55.9993 43.7375 43.4012 43.7375 17.188C43.7882 12.6606 45.7207 8.33492 49.1155 5.15041C52.5103 1.9659 57.0931 0.179687 61.8687 0.179688C66.6444 0.179687 71.2272 1.9659 74.622 5.15041C78.0167 8.33492 79.9493 12.6606 79.9999 17.188Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesTop);
export default __webpack_public_path__ + "static/media/QuotesTop.876c869ba8c9beda4a842e6b896775ad.svg";
export { ForwardRef as ReactComponent };